export default function resetSelectedOptionsInForm(form) {
  function action(context) {
    let state = context.state
    let fields = state.get(form)
    Object.keys(fields).forEach(key => {
      let field = fields[key]
      if (field.type === 'select' && field.options.length > 0) {
        let selectedIndex = null
        if (field.defaultValue.length > 0) {
          selectedIndex = field.defaultValue[0].index
        }
        let options = field.options.map(option => {
          return {
            ...option,
            selected: selectedIndex === option.index || false
          }
        })
        state.set(`${form}.${key}.options`, options)
      }
    })
  }
  return action
}



// WEBPACK FOOTER //
// ./src/modules/user/factories/resetSelectedOptionsInForm.js